/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */

"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var constants = require("../../../lib/shared/constants");
var GIT_SERVICE_IDS = constants.gitServiceIds;
var WizardStep = /*#__PURE__*/function () {
  function WizardStep(wizardStepData, getWizard) {
    _classCallCheck(this, WizardStep);
    this.data = wizardStepData;
    this.getWizard = getWizard;
    this.mode = "standard";
  }
  return _createClass(WizardStep, [{
    key: "getName",
    value: function getName() {
      return this.data.name;
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this.data.label || this.getTitle();
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      return this.data.title;
    }
  }, {
    key: "getImageUrl",
    value: function getImageUrl() {
      return this.data.image_url;
    }
  }, {
    key: "getForm",
    value: function getForm() {
      return this.data.form;
    }
  }, {
    key: "isSecretsStep",
    value: function isSecretsStep() {
      return this.data.secretsStep;
    }
  }, {
    key: "hasAdvancedForm",
    value: function hasAdvancedForm() {
      return !!this.data.advanced_form;
    }
  }, {
    key: "indentLevel",
    value: function indentLevel() {
      return this.data.indent_level;
    }
  }, {
    key: "getRenderData",
    value: function getRenderData() {
      if (this.hasAdvancedForm()) {
        var cap = this._getModel().getByLabel(this._getAdvancedForm());
        if (!cap) {
          // When switching source provider we temporarily have steps with no capability to render
          // Avoid returning null here to fix issue: https://github.ibm.com/org-ids/roadmap/issues/18232
          return {
            toolCapabilities: []
          };
        }
        return {
          tool: cap.capabilityId,
          toolMetadata: this._getModel().getMetadata(cap.capabilityId),
          toolCapabilities: [cap]
        };
      } else {
        var tool = this.getForm();
        var caps = this._getModel().getByType(tool);
        if (caps.length > 0) {
          return {
            tool: tool,
            toolMetadata: this._getModel().getMetadata(tool),
            toolCapabilities: this._filterVisibleCapabilities(caps)
          };
        } else {
          var _cap = this._getModel().getByLabel(tool);
          if (!_cap) {
            // Avoid null pointer when user is not logged in
            return {
              toolCapabilities: []
            };
          }
          return {
            tool: _cap.capabilityId,
            toolMetadata: this._getModel().getMetadata(_cap.capabilityId),
            toolCapabilities: [_cap]
          };
        }
      }
    }
  }, {
    key: "_filterVisibleCapabilities",
    value: function _filterVisibleCapabilities(caps) {
      var _this = this;
      return caps.filter(function (cap) {
        var form = cap.__form;
        if (!form || _this.hasAdvancedForm()) {
          return true;
        }
        return !form.schema;
      });
    }
  }, {
    key: "getVisibleCapabilities",
    value: function getVisibleCapabilities() {
      return this.getRenderData().toolCapabilities;
    }
  }, {
    key: "isVisibleCapability",
    value: function isVisibleCapability(label) {
      return !!this.getVisibleCapabilities().find(function (cap) {
        return cap.label === label;
      });
    }
  }, {
    key: "getFormMetadata",
    value: function getFormMetadata(schema) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$authFlow = _ref.authFlow,
        authFlow = _ref$authFlow === void 0 ? false : _ref$authFlow;
      if (!this.hasAdvancedForm()) {
        return schema.form;
      }

      // Shallow copy the advanced form
      var returnForm = _toConsumableArray(schema.form);

      // Shallow copy the standard form
      var standardForm = _toConsumableArray(this._getModel().getMetadata(this.getForm()).form);

      // Save the advanced validator for later
      var validator = returnForm.find(function (item) {
        return item.type === "validator";
      });
      if (this.getMode() !== "advanced") {
        // Swap in the standard form
        if (this._getAdvancedWaitForPopulate()) {
          if (schema.populateComplete) {
            // Only show the Authorize button in standard mode
            returnForm = authFlow ? [] : standardForm;
          }
        } else {
          returnForm = standardForm;
        }

        // Copy select enums from the advanced form to the corresponding standard form selects
        this._mirrorAdvancedEnum(returnForm, schema);
      }
      if (returnForm !== standardForm) {
        // Insert "showInAdvancedMode" items into the advanced form
        standardForm && standardForm.forEach(function (item) {
          if (item.display && item.display.showInAdvancedMode === true) {
            if (item.display.advancedModePosition === "bottom") {
              returnForm.push(item);
            } else {
              returnForm.unshift(item);
            }
          }
        });
      }
      if (validator) {
        // Ensure the advanced validator is first on the form
        returnForm = returnForm.filter(function (item) {
          return item.type !== "validator";
        });
        returnForm.unshift(validator);
      }
      return returnForm;
    }
  }, {
    key: "getFormLongDescription",
    value: function getFormLongDescription() {
      if (this.hasAdvancedForm() && this.getMode() !== "advanced") {
        return this._getModel().getMetadata(this.getForm()).longDescription;
      }
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      if (this.getForm() && this._getModel().getByType(this.getForm())) {
        if (this._getVisibleCondition()) {
          return this._evaluateCondition(this._getVisibleCondition());
        } else if (this.data.visible !== undefined) {
          return !!this.data.visible;
        }
        return true;
      }
      return false;
    }
  }, {
    key: "handleParameterChange",
    value: function handleParameterChange(capability, changeSummary) {
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        callback = _ref2.callback;
      var changedParams = changeSummary && Object.keys(changeSummary).filter(function (param) {
        return changeSummary[param].source === "user";
      });
      if (changedParams && changedParams.length > 0) {
        this._processConditions(capability, changedParams, {
          callback: callback
        });
      }
    }
  }, {
    key: "setMode",
    value: function setMode(mode) {
      this.mode = mode;
    }
  }, {
    key: "getMode",
    value: function getMode() {
      return this.mode;
    }
  }, {
    key: "handleGitAcceptChange",
    value: function handleGitAcceptChange(value) {
      var capability = this._getModel().getByLabel(this._getAdvancedForm());
      if (!!(capability && GIT_SERVICE_IDS.includes(capability.service_id))) {
        capability.parameters.legal = value;
        return capability;
      }
    }
  }, {
    key: "_mirrorAdvancedEnum",
    value: function _mirrorAdvancedEnum(form, schema) {
      var _this2 = this;
      var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      form.forEach(function (item) {
        // TODO remove "item.mirrorAdvancedEnum" when CI/CD templates have been updated
        if (item.type === "select" && (item.mirrorAdvancedEnum || item.display && item.display.mirrorAdvancedEnum)) {
          // Find the advanced mode item and copy the enum
          var findPath = path ? "".concat(path, ".").concat(item.key) : item.key;
          item.enum = _this2._getAdvancedEnum(findPath, schema.form || [], schema);
        } else {
          switch (item.type) {
            case "subform":
            case "section":
            case "group":
            case "table":
            case "accordion":
              // Recurse down through the children
              _this2._mirrorAdvancedEnum(item.items || [], schema, path);
              break;
            case "selectfieldset":
              var enumList = item.enum;
              if (enumList && item.items) {
                for (var i = 0; i < enumList.length; i++) {
                  var enumItem = item.items[i];
                  if (enumItem) {
                    // Recurse down through each enum option
                    var newPath = path ? "".concat(path, ".").concat(enumList[i]) : enumList[i];
                    _this2._mirrorAdvancedEnum([enumItem], schema, newPath);
                  }
                }
              }
              break;
          }
        }
      });
    }

    // Function to find an advanced form select control and return the enum
  }, {
    key: "_getAdvancedEnum",
    value: function _getAdvancedEnum(findPath, form, schema) {
      var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
      for (var i = 0; i < form.length; i++) {
        var item = form[i];
        if (item.type === "select") {
          var newPath = path ? "".concat(path, ".").concat(item.key) : item.key;
          if (newPath.endsWith(findPath)) {
            // We've found the matching advanced enum
            return item.enum;
          }
        } else {
          switch (item.type) {
            case "subform":
            case "section":
            case "group":
            case "table":
            case "accordion":
              // Recurse down through the children
              var result = this._getAdvancedEnum(findPath, item.items || [], schema, path);
              if (result) {
                return result;
              }
              break;
            case "selectfieldset":
              var enumList = item.enum || schema.properties && schema.properties[item.key] && schema.properties[item.key].enum;
              if (enumList && item.items) {
                for (var _i = 0; _i < enumList.length; _i++) {
                  var enumItem = item.items[_i];
                  if (enumItem) {
                    // Recurse down through each enum option
                    var _newPath = path ? "".concat(path, ".").concat(enumList[_i]) : enumList[_i];
                    var _result = this._getAdvancedEnum(findPath, [enumItem], schema, _newPath);
                    if (_result) {
                      return _result;
                    }
                  }
                }
              }
              break;
          }
        }
      }
    }
  }, {
    key: "_getVisibleCondition",
    value: function _getVisibleCondition() {
      return this.data.visible && this.data.visible.condition;
    }
  }, {
    key: "_getModel",
    value: function _getModel() {
      return this.getWizard().getModel();
    }
  }, {
    key: "_getAdvancedForm",
    value: function _getAdvancedForm() {
      return this.data.advanced_form;
    }
  }, {
    key: "_getAdvancedWaitForPopulate",
    value: function _getAdvancedWaitForPopulate() {
      var capability = this._getModel().getByLabel(this._getAdvancedForm());
      return !!(capability && GIT_SERVICE_IDS.includes(capability.service_id));
    }
  }, {
    key: "_getConditions",
    value: function _getConditions() {
      return this.data.conditions || [];
    }
  }, {
    key: "_processConditions",
    value: function _processConditions(capability, changedParams, _ref3) {
      var _this3 = this;
      var callback = _ref3.callback;
      if (this.getForm() === capability.label || this._getAdvancedForm() === capability.label) {
        this._getConditions().forEach(function (condition) {
          if (_this3._shouldEvaluateCondition(condition.condition, changedParams) && _this3._evaluateCondition(condition.condition)) {
            condition.actions.forEach(function (action) {
              _this3._performAction(action, {
                callback: callback
              });
            });
          }
        });
      }
    }
  }, {
    key: "_performAction",
    value: function _performAction(action, _ref4) {
      var _this4 = this;
      var callback = _ref4.callback;
      switch (action.type) {
        case 'create-service':
          this._getModel().addToolIntegration(action.service_id, {
            label: action.service_label
          }, action.parameters);
          callback && callback({
            type: action.type,
            service: action.service_id
          });
          break;
        case 'delete-service':
          this._getModel().removeToolIntegration(action.service_id, {
            label: action.service_label,
            force_delete: true
          });
          callback && callback({
            type: action.type,
            service: action.service_id
          });
          break;
        case 'update-service':
          this._getModel().updateToolIntegration(action.service_id, action.service_label, action.parameters, {
            keep_service: false,
            keep_parameters: action.keep_parameters
          });
          callback && callback({
            type: action.type,
            service: action.service_id
          });
          break;
        case 'update-service-parameters':
          this._getModel().updateToolIntegration(action.service_id, action.service_label, action.parameters, {
            keep_service: true
          });
          callback && callback({
            type: action.type,
            service: action.service_id
          });
          break;
        case 'show-controls':
          action.controls && action.controls.forEach(function (control) {
            var form = _this4._getModel().getByLabel(control.form);
            if (form && form.metadata && form.metadata.form && control.ids) {
              form.metadata.form.forEach(function (formControl) {
                if (control.ids.includes(formControl.display && formControl.display.controlId)) {
                  delete formControl.visible;
                }
              });
            }
          });
          callback && callback({
            type: action.type
          });
          break;
        case 'hide-controls':
          action.controls && action.controls.forEach(function (control) {
            var form = _this4._getModel().getByLabel(control.form);
            if (form && form.metadata && form.metadata.form && control.ids) {
              form.metadata.form.forEach(function (formControl) {
                if (control.ids.includes(formControl.display && formControl.display.controlId)) {
                  formControl.visible = false;
                }
              });
            }
          });
          callback && callback({
            type: action.type
          });
          break;
      }
    }
  }, {
    key: "_shouldEvaluateCondition",
    value: function _shouldEvaluateCondition(condition, changedParams) {
      var _this5 = this;
      if (condition.any) {
        return !!condition.any.find(function (c) {
          if (c.any || c.all || c.none) {
            return _this5._shouldEvaluateCondition(c, changedParams);
          }
          return changedParams && changedParams.includes(c.parameter);
        });
      } else if (condition.all) {
        return !!condition.all.find(function (c) {
          if (c.any || c.all || c.none) {
            return _this5._shouldEvaluateCondition(c, changedParams);
          }
          return changedParams && changedParams.includes(c.parameter);
        });
      } else if (condition.none) {
        return !!condition.none.find(function (c) {
          if (c.any || c.all || c.none) {
            return _this5._shouldEvaluateCondition(c, changedParams);
          }
          return changedParams && changedParams.includes(c.parameter);
        });
      }
      return false;
    }
  }, {
    key: "_evaluateCondition",
    value: function _evaluateCondition(condition) {
      var _this6 = this;
      if (condition.any) {
        // If we find any true condition then success
        return !!condition.any.find(function (c) {
          if (c.any || c.all || c.none) {
            return _this6._evaluateCondition(c);
          }
          var form = _this6._getModel().getByLabel(c.form || _this6._getAdvancedForm() || _this6.getForm());
          return form && form.parameters && form.parameters.hasOwnProperty(c.parameter) && form.parameters[c.parameter] === c.value;
        });
      } else if (condition.all) {
        // If we find any false condition then fail
        return !condition.all.find(function (c) {
          if (c.any || c.all || c.none) {
            return !_this6._evaluateCondition(c);
          }
          var form = _this6._getModel().getByLabel(c.form || _this6._getAdvancedForm() || _this6.getForm());
          return !(form && form.parameters && form.parameters.hasOwnProperty(c.parameter) && form.parameters[c.parameter] === c.value);
        });
      } else if (condition.none) {
        // If we find any true condition then fail
        return !condition.none.find(function (c) {
          if (c.any || c.all || c.none) {
            return _this6._evaluateCondition(c);
          }
          var form = _this6._getModel().getByLabel(c.form || _this6._getAdvancedForm() || _this6.getForm());
          return form && form.parameters && form.parameters.hasOwnProperty(c.parameter) && form.parameters[c.parameter] === c.value;
        });
      }
      return false;
    }
  }, {
    key: "findServiceInCondition",
    value: function findServiceInCondition(condition, parameter) {
      var _this7 = this;
      var searchObj;
      if (condition.condition.any) {
        searchObj = condition.condition.any;
      } else if (condition.all) {
        searchObj = condition.condition.all;
      } else if (condition.none) {
        searchObj = condition.condition.none;
      }
      if (searchObj) {
        var matchesService = !!searchObj.find(function (c) {
          if (c.any || c.all || c.none) {
            return _this7.findServiceInCondition(c, parameter);
          }
          var conditionKey = c.parameter;
          var conditionValue = c.value;
          return conditionValue && conditionKey === parameter;
        });
        if (matchesService) {
          var createAction = condition.actions.find(function (a) {
            return a.type === "create-service";
          });
          return createAction === null || createAction === void 0 ? void 0 : createAction.service_id;
        }
      }
      return null;
    }
  }]);
}();
module.exports = WizardStep;